import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import SideNav from '../components/navs/SideNav';
import MainHeader from '../components/shared/MainHeader';
import { getTheme, screen } from '../global/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBars } from '@fortawesome/free-solid-svg-icons';

let $this;

const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  .sidenav {
    width: 248px;
    transition: margin-left 0.3s;
    flex-shrink: 0;
  }
  .main-container {
    flex-grow: 1;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .main-content {
    flex-grow: 1;
    overflow: auto;
    position: relative;
    @media (max-width: ${screen('xlMax')}) {
      width: 100vw;
    }
    ${props =>
      props.layoutColor === 'alt' &&
      css`
        background-color: ${getTheme('bg', 'light2')};
      `};
  }

  .nav-trigger {
    width: ${getTheme('height', 'header')};
    height: ${getTheme('height', 'header')};
    background-color: ${getTheme('bg', 'dark1')};
    color: ${getTheme('textColor', 'white')};
    font-size: ${getTheme('fontSize', 'body')};
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &:focus {
      outline: 0;
    }
  }

  .nav-trigger__close {
    display: flex;
  }
  .nav-trigger__open {
    display: none;
    font-size: ${getTheme('fontSize', 'title')};
  }

  ${props =>
    props.menuVisibility === false &&
    css`
      .sidenav {
        margin-left: -248px;
      }

      .nav-trigger__close {
        display: none;
      }
      .nav-trigger__open {
        display: flex;
      }
    `};
`;

class MainLayout extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      menuVisible: true,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState({
      menuVisible: !this.state.menuVisible,
    });
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  widthChange(mq) {
    if (mq.matches) {
      $this.setState({
        menuVisible: true,
      });
    } else {
      $this.setState({
        menuVisible: false,
      });
    }
  }

  componentDidMount() {
    const mq = window.matchMedia('(min-width: 900px)');
    $this = this;
    mq.addListener(this.widthChange);
    this.widthChange(mq);
  }

  render() {
    return (
      <Layout layoutColor={this.props.layoutColor} menuVisibility={this.state.menuVisible}>
        <div className="sidenav">
          <SideNav />
        </div>

        <div className="main-container">
          <MainHeader>
            <button className="nav-trigger" onClick={this.toggleMenu}>
              <FontAwesomeIcon className="nav-trigger__close" icon={faTimes} />
              <FontAwesomeIcon className="nav-trigger__open" icon={faBars} />
            </button>
          </MainHeader>
          <div className={`main-content ${this.props.className}`}>{this.props.children}</div>
        </div>
      </Layout>
    );
  }
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js